import { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { buttonloginstyle } from "../help/Utils";
import reset from "../assets/reset.png";
import secure from "../assets/secure.png";
import "aos/dist/aos.css";
import { MdCancel } from "react-icons/md";
import { FaCircleCheck } from "react-icons/fa6";
import Hints from "../components/Hints";
import apiClient from "../API";

const ChangePassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Password requirements checks
  const hasLength = password.length >= 8;
  const hasUpperLower = /[a-z]/.test(password) && /[A-Z]/.test(password);
  const hasNumber = /\d/.test(password);
  const hasSpecial = /[^A-Za-z0-9]/.test(password);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      setError("Please fill out both password fields.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    if (!hasLength || !hasUpperLower || !hasNumber || !hasSpecial) {
      setError("Password does not meet all requirements.");
      return;
    }

    try {
      const res = await apiClient.post(`/auth/reset-password/${token}`, {
        password: password,
      });

      console.log("Password updated:", res.data);
      setSuccess("✅ Password updated successfully.");
      setError("");

      setTimeout(() => navigate("/"), 3000);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Something went wrong. Try again.");
    }
  };

  return (
    <div className="relative login_main body_padding pb-[100px] ">
      <div className="text-center">
        <img src={reset} alt="reset icon" className="mx-auto mb-3" />
      </div>
      <h1 className="mb-2 text-center">Change Password</h1>
      <p className="text-center mb-10 text-[18px]">
        Create a new secure password for your account
      </p>

      <form
        onSubmit={handleSubmit}
        className="bg-white rounded-xl border border-gray-200 shadow-sm sm:p-[35px] p-5 rounded-2xl w-full max-w-[90%] sm:max-w-[500px] mx-auto login_form"
      >
        <div>
          <label className="mt-2 flex text-sm font-semibold">New Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your new password"
            className={`border border-gray-200 rounded-lg w-full py-[14px] px-[16px] text-base `}
          />
        </div>

        <div>
          <label className="mt-5 flex text-sm font-semibold">
            Confirm New Password
          </label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirm your new password"
            className={`border border-gray-200 rounded-lg w-full py-[14px] px-[16px] text-base `}
          />
        </div>

        <div className="border border-[#E5E7EB] bg-[#F9FAFB] p-6 rounded-[12px] flex items-start mb-[25px] mt-5">
          <div>
            <p className="text-[#374151] font-semibold text-[14px] leading-[20px] mb-2">
              Password requirements:
            </p>
            <ul className="list-none text-[14px] text-[#4B5563]">
              <li className="mb-1 flex items-center">
                {hasLength ? (
                  <FaCircleCheck className="text-[18px] text-[#41C700] me-2" />
                ) : (
                  <MdCancel className="text-[18px] text-[#FF272A] me-2" />
                )}
                At least 8 characters long
              </li>
              <li className="mb-1 flex items-center">
                {hasUpperLower ? (
                  <FaCircleCheck className="text-[18px] text-[#41C700] me-2" />
                ) : (
                  <MdCancel className="text-[18px] text-[#FF272A] me-2" />
                )}
                Contains uppercase and lowercase letters
              </li>
              <li className="mb-1 flex items-center">
                {hasNumber ? (
                  <FaCircleCheck className="text-[18px] text-[#41C700] me-2" />
                ) : (
                  <MdCancel className="text-[18px] text-[#FF272A] me-2" />
                )}
                Contains at least one number
              </li>
              <li className="flex items-center">
                {hasSpecial ? (
                  <FaCircleCheck className="text-[18px] text-[#41C700] me-2" />
                ) : (
                  <MdCancel className="text-[18px] text-[#FF272A] me-2" />
                )}
                Contains at least one special character
              </li>
            </ul>
          </div>
        </div>

        {error && <p className="text-red-500 text-sm mb-2">{error}</p>}
        {success && <p className="text-green-600 text-sm mb-2">{success}</p>}

        <button type="submit" style={buttonloginstyle} className={`w-full mb-5`}>
          Update Password
        </button>

        <div className="pt-5 border-t border-gray-200 ">
          <p className="text-center font-semibold">
            Back to{" "}
            <Link to="/" className="text-[#E76F51] font-bold">
              Login
            </Link>
          </p>
        </div>
      </form>

      <div className="mt-2 flex justify-center items-center ">
        <img src={secure} alt="secure login" className="me-3" />
        Your password is encrypted and secure
      </div>

      <Hints
        title="Security Tip"
        message="Use a unique password that you don't use for other accounts. Consider using a password manager for better security."
      />
    </div>
  );
};

export default ChangePassword;
